import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-recieve-by-case',
  templateUrl: './recieve-by-case.component.html',
  styleUrls: ['./recieve-by-case.component.scss']
})
export class RecieveByCaseComponent implements OnInit,OnDestroy {
  form: FormGroup = new FormGroup({
    receivedQty: new FormControl(1, Validators.required),
  })
  totalQty: any;
  private destroy$ = new Subject<void>();
  
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<RecieveByCaseComponent>,) { }
 
  ngOnInit(): void {
    this.totalQty= this.data.qtyPerCase * this.form.controls.receivedQty.value;
    this.form.get("receivedQty").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if(value){
        this.totalQty= value * this.data.qtyPerCase;
      }
    })
  }

   onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  dialogAction(e) {
    if (e === "Update") {
      this.recieve();
    } 
     else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  recieve() {
    this.dialogRef.close(this.totalQty);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
